import PropTypes from "prop-types";

import { selectedStateIndicatorCss } from "./SelectedStateIndicator.style";

const propTypes = {
  shouldDisplay: PropTypes.bool,
};

const SelectedStateIndicator = ({ shouldDisplay }) => {
  return <>{shouldDisplay ? <div css={selectedStateIndicatorCss} /> : null}</>;
};

SelectedStateIndicator.propTypes = propTypes;

export default SelectedStateIndicator;
